export const COGNITO_GRUPPE_SACHVERSTAENGIGER = 'Sachverstaendiger';
export const COGNITO_GRUPPE_QUALITAETSSICHERUNG = 'Qualitaetssicherung';
export const COGNITO_GRUPPE_VERWALTUNG = 'Verwaltung';
export const COGNITO_GRUPPE_ADMIN = 'Admin';
export const COGNITO_GRUPPE_EXPERTS24ADMIN = 'Experts24Admin';

export const EVENT_TYPE_ZAHLUNG_IMPORTIERT = 'ZAHLUNG_IMPORTIERT';
export const EVENT_TYPE_ZAHLUNG_GELOESCHT = 'ZAHLUNG_GELOESCHT';

// Reihenfolge ist richtig und wichtig
export enum Status {
  OFFEN = 'OFFEN',
  TERMINFESTLEGUNG = 'TERMINFESTLEGUNG',
  BESICHTIGUNG = 'BESICHTIGUNG',
  BEWEISSICHERUNG = 'BEWEISSICHERUNG',
  GUTACHTENAUSARBEITUNG = 'GUTACHTENAUSARBEITUNG',
  QUALITAETSSICHERUNG = 'QUALITAETSSICHERUNG',
  DRUCK_VERSAND = 'DRUCK_VERSAND',
  MAHNWESEN = 'MAHNWESEN',
  ABGESCHLOSSEN = 'ABGESCHLOSSEN'
}

export const AKTIVE_VORGAENGE = [Status.OFFEN, Status.BESICHTIGUNG, Status.TERMINFESTLEGUNG, Status.GUTACHTENAUSARBEITUNG] as const;

export enum Gutachtenart {
  SCHADENSGUTACHTEN_HAFTPFLICHT = 'SCHADENSGUTACHTEN_HAFTPFLICHT',
  SCHADENSGUTACHTEN_KASKO = 'SCHADENSGUTACHTEN_KASKO',
  KURZGUTACHTEN = 'KURZGUTACHTEN',
  REPARATURNACHWEIS = 'REPARATURNACHWEIS',
  FAHRZEUGBEWERTUNG = 'FAHRZEUGBEWERTUNG'
}

export enum Bereifung {
  WINTERREIFEN = 'WINTERREIFEN',
  SOMMERREIFEN = 'SOMMERREIFEN',
  GANZJAHRESREIFEN = 'GANZJAHRESREIFEN'
}

// DAT mapping for tire types (Art)
export enum BereifungsartDAT {
  SOMMER = '0',
  WINTER = 'M+S',
  ALLWETTER = 'AS',
  ALL_TERRAIN = 'AT',
  MUD_TERRAIN = 'MT'
}

// Common tire safety systems
export const SICHERHEITSSYSTEME = [
  'Run Flat',
  'Self Supporting Run Flat',
  'Reinforced',
  'Extra Load',
  'XL',
  'C',
  'LT',
  'ST',
  'Temporary Spare',
  'T-Type',
  'Space Saver'
];

// Common speed index values
export const GESCHWINDIGKEITSINDEX = [
  'A1',
  'A2',
  'A3',
  'A4',
  'A5',
  'A6',
  'A7',
  'A8',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'J',
  'K',
  'L',
  'M',
  'N',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'H',
  'V',
  'W',
  'Y',
  'ZR'
];

// Tire brands/models by manufacturer
export const REIFENMARKEN_BY_HERSTELLER: Record<string, string[]> = {
  Michelin: ['Pilot Sport', 'Primacy', 'Energy Saver', 'CrossClimate', 'Alpin', 'X-Ice', 'Latitude', 'Agilis'],
  Bridgestone: ['Potenza', 'Turanza', 'Ecopia', 'Blizzak', 'Dueler', 'DriveGuard'],
  Continental: ['PremiumContact', 'EcoContact', 'SportContact', 'WinterContact', 'CrossContact', 'VanContact'],
  Pirelli: ['P Zero', 'Cinturato', 'Winter Sottozero', 'Scorpion', 'Cinturato P7'],
  Goodyear: ['Eagle', 'Vector', 'UltraGrip', 'DuraGrip', 'Wrangler', 'Assurance'],
  Dunlop: ['Sport Maxx', 'SP Sport', 'Winter Sport', 'Grandtrek', 'SP QuattroMaxx'],
  Hankook: ['Ventus', 'Kinergy', 'Winter i*cept', 'Dynapro', 'Optimo'],
  Yokohama: ['Advan', 'BluEarth', 'IceGuard', 'Geolandar', 'dB'],
  Falken: ['Azenis', 'Sincera', 'Eurowinter', 'Wildpeak', 'Ziex'],
  Kumho: ['Ecsta', 'Solus', "I'Zen", 'Road Venture', 'Crugen'],
  Toyo: ['Proxes', 'Celsius', 'Open Country', 'Versado', 'Extensa'],
  Nokian: ['Hakkapeliitta', 'Line', 'WR', 'eNTYRE', 'Rotiva'],
  Cooper: ['Zeon', 'Discoverer', 'Weather-Master', 'Evolution', 'CS5'],
  'BF Goodrich': ['g-Force', 'Advantage', 'Mud-Terrain', 'All-Terrain', 'Radial T/A'],
  Firestone: ['Firehawk', 'Destination', 'Winterforce', 'Champion', 'Affinity'],
  Uniroyal: ['RainSport', 'Tiger Paw', 'Rallye', 'Laredo', 'Steel Belted Radial'],
  General: ['G-Max', 'Altimax', 'Grabber', 'AmeriMax', 'Exclaim'],
  Vredestein: ['Quatrac', 'Ultrac', 'Wintrac', 'Comtrac', 'Sprint+'],
  Avon: ['ZZ5', 'ZV7', 'Ice Touring', 'Ranger', 'Touring'],
  Barum: ['Bravuris', 'Brisa', 'Polaris', 'Quartaris', 'Matador']
};

export enum Allgemeinzustand {
  DURCHSCHNITTLICHER_ZUSTAND = 'DURCHSCHNITTLICHER_ZUSTAND',
  UEBERDURCHSCHNITTLICHER_ZUSTAND = 'UEBERDURCHSCHNITTLICHER_ZUSTAND',
  UNTERDURCHSCHNITTLICHER_ZUSTAND = 'UNTERDURCHSCHNITTLICHER_ZUSTAND'
}

export enum AltschadenEnum {
  KEINE_ALTSCHAEDEN_AEUSSERLICH_ERKENNBAR = 'KEINE_ALTSCHAEDEN_AEUSSERLICH_ERKENNBAR',
  ALTSCHAEDEN_VORHANDEN = 'ALTSCHAEDEN_VORHANDEN'
}

export enum Zulassungsbescheinigung {
  ZULASSUNGSBESCHEINIGUNG_I = 'ZULASSUNGSBESCHEINIGUNG_I',
  ZULASSUNGSBESCHEINIGUNG_II = 'ZULASSUNGSBESCHEINIGUNG_II'
}

export enum Reifenzustand {
  VERKEHRSSICHER = 'VERKEHRSSICHER',
  NICHT_VERKEHRSSICHER = 'NICHT_VERKEHRSSICHER'
}

export enum Fahrzeugart {
  PKW = 'PKW',
  LKW = 'LKW',
  KRAFTRAD = 'KRAFTRAD',
  KRAFTOMNIBUS = 'KRAFTOMNIBUS',
  FAHRRAD = 'FAHRRAD',
  SONSTIGES = 'SONSTIGES'
}

export enum Unterzeichner {
  VERMITTLER = 'VERMITTLER',
  AUFTRAGGEBER = 'AUFTRAGGEBER',
  FAHRZEUGHALTER = 'FAHRZEUGHALTER',
  SACHVERSTAENDIGER = 'SACHVERSTAENDIGER'
}

export enum Dateityp {
  FOTO = 'FOTO',
  DOKUMENT = 'DOKUMENT'
}

export enum Generierungsstatus {
  ANGEFRAGT = 'ANGEFRAGT',
  IN_ERSTELLUNG = 'IN_ERSTELLUNG',
  ERSTELLT = 'ERSTELLT',
  FEHLGESCHLAGEN = 'FEHLGESCHLAGEN'
}

export enum EmailEmpfaengerTyp {
  VERSICHERUNG = 'VERSICHERUNG',
  RECHTSANWALT = 'RECHTSANWALT',
  VERMITTLER = 'VERMITTLER',
  AUFTRAGGEBER = 'AUFTRAGGEBER',
  FAHRZEUGHALTER = 'FAHRZEUGHALTER',
  SACHVERSTAENDIGER = 'SACHVERSTAENDIGER',
  WERKSTATT = 'WERKSTATT',
  SONSTIGE = 'SONSTIGE'
}

export enum PersonenTyp {
  PERSON = 'PERSON',
  VERMITTLER = 'VERMITTLER',
  UNFALLGEGNER = 'UNFALLGEGNER'
}

export enum Anrede {
  HERR = 'HERR',
  FRAU = 'FRAU',
  FIRMA = 'FIRMA'
}

export enum UnternehmenTyp {
  VERSICHERUNG = 'VERSICHERUNG',
  RECHTSANWALT = 'RECHTSANWALT',
  WERKSTATT = 'WERKSTATT',
  HAENDLER = 'HAENDLER'
}

export enum Rechnungsposition {
  GRUNDHONORAR = 'GRUNDHONORAR',
  GRUNDHONORAR_E_FAHRZEUG = 'GRUNDHONORAR_E_FAHRZEUG',
  FOTOSATZ_EINS = 'FOTOSATZ_EINS',
  FOTOSATZ_ZWEI = 'FOTOSATZ_ZWEI',
  FAHRTKOSTEN = 'FAHRTKOSTEN',
  FAHRTKOSTEN_NACHBESICHTIGUNG = 'FAHRTKOSTEN_NACHBESICHTIGUNG',
  KOMMUNIKATIONSPAUSCHALE = 'KOMMUNIKATIONSPAUSCHALE',
  SCHREIBKOSTEN_KOPIEN = 'SCHREIBKOSTEN/KOPIEN',
  FREMDRECHNUNG = 'FREMDRECHNUNG',
  NACHBESICHTIGUNG = 'NACHBESICHTIGUNG',
  KALKULATIONSKOSTEN_DAT = 'KALKULATIONSKOSTEN_DAT',
  AUSLESUNG_E_FAHRZEUG = 'AUSLESUNG_E_FAHRZEUG',
  LACKSCHICHTENDICKENMESSUNG = 'LACKSCHICHTENDICKENMESSUNG'
}

export enum RechnungspositionEinheit {
  EURO = 'EURO',
  STD = 'STD',
  KM = 'KM',
  STK = 'STK'
}

export enum DateiKategorie {
  RECHNUNG = 'Rechnung',
  ANGEBOT = 'Angebot',
  HIS = 'HIS Antwort',
  FREMDRECHNUNG = 'Fremdrechnung',
  UNTERSCHRIFTEN = 'Unterschriften',
  WEBSCAN = 'WebScan',
  LACKSCHICHTENDICKENMESSUNG = 'Lackschichtendickenmessung',
  GUTSCHRIFT = 'Gutschrift',
  STORNO = 'Storno'
}

export const RECHNUNGSPOSITION_EINHEIT_AUSWAHL: Array<{ label: string; value: RechnungspositionEinheit }> = [
  { label: '€', value: RechnungspositionEinheit.EURO },
  { label: 'km', value: RechnungspositionEinheit.KM },
  { label: 'Stunde', value: RechnungspositionEinheit.STD },
  { label: 'Stück', value: RechnungspositionEinheit.STK }
];

export const RECHNUNGSPOSITION_AUSWAHL = [
  { label: 'Grundhonorar', value: Rechnungsposition.GRUNDHONORAR },
  { label: 'Grundhonorar E-Fahrzeug', value: Rechnungsposition.GRUNDHONORAR_E_FAHRZEUG },
  { label: '1. Fotosatz', value: Rechnungsposition.FOTOSATZ_EINS },
  { label: '2. Fotosatz', value: Rechnungsposition.FOTOSATZ_ZWEI },
  { label: 'Fahrtkosten', value: Rechnungsposition.FAHRTKOSTEN },
  { label: 'Fahrtkosten Nachbesichtigung', value: Rechnungsposition.FAHRTKOSTEN_NACHBESICHTIGUNG },
  { label: 'Kommunikationspauschale', value: Rechnungsposition.KOMMUNIKATIONSPAUSCHALE },
  { label: 'Schreibkosten/Kopien', value: Rechnungsposition.SCHREIBKOSTEN_KOPIEN },
  { label: 'Fremdrechnung', value: Rechnungsposition.FREMDRECHNUNG },
  { label: 'Nachbesichtigung (0,5 Stunden)', value: Rechnungsposition.NACHBESICHTIGUNG },
  { label: 'Kalkulationskosten DAT', value: Rechnungsposition.KALKULATIONSKOSTEN_DAT },
  { label: 'Auslesung E-Fahrzeug', value: Rechnungsposition.AUSLESUNG_E_FAHRZEUG },
  { label: 'Lackschichtendickenmessung', value: Rechnungsposition.LACKSCHICHTENDICKENMESSUNG }
];

export type TokenContainer = {
  valuateExpertToken?: string;
  calculateExpertToken?: string;
  fahrzeugauswahlToken?: string;
  rentalPricesToken?: string;
};

export type DatZugangsdaten = {
  customerNumber: string | null;
  customerLogin: string | null;
  customerPassword: string | null;
  interfacePartnerNumber: string | null;
  interfacePartnerSignature: string | null;
};

export type Lackart = {
  description: string;
  key: string;
};

export type Land = {
  nationalitaet: string;
  land: string;
};

export type ChallengeName = 'CUSTOM_CHALLENGE' | 'MFA_SETUP' | 'NEW_PASSWORD_REQUIRED' | 'SELECT_MFA_TYPE' | 'SMS_MFA' | 'SOFTWARE_TOKEN_MFA';

export interface CognitoUserCustomAttributes {
  'custom:kuerzel': string;
  'cognito:groups': string[];
}

export interface CognitoUser {
  username: string;
  attributes: {
    email: string;
    family_name: string;
    given_name: string;
    'custom:mandant': string;
    'custom:kuerzel': string;
  };
  signInUserSession?: {
    idToken: {
      payload: CognitoUserCustomAttributes;
      jwtToken: string;
    };
  };
  unverified: {
    email: string;
  };
  challengeName?: ChallengeName;
}

type BoundingBox = {
  width: number;
  height: number;
  left: number;
  top: number;
};

export type Word = {
  text: string;
  boundingBox: BoundingBox;
};

export type IdentifyTextOutputText = {
  fullText: string;
  lines: string[];
  linesDetailed: Word[];
  words: Word[];
};

export type Feld = {
  objekt: string;
  feld: string;
  label: string;
  value: string;
  word: Word;
  type: string;
};

export type TexterkennungKategorie = {
  kategorie: string;
  word: Word;
};

export type SelectOption = {
  label: string;
  value: string;
};

export type DownloadImage = {
  type: string;
  data: string;
};
